/* eslint-disable max-classes-per-file */
import { QuestionModel } from 'core/models/elements/questions/question.abstract.model';
import { AreaModel } from '../components/area.model';

/**
 * @class Defines a hotspot question.
 */
export class HotspotQuestionModel extends QuestionModel {
  /**
   * @constructor Creates an instance of a hotspot question built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo) {
    super(bo);
    this.srcBackgroundImage = bo.source_background_image;
    this.areas = bo.areas?.map((area) => new AreaModel(area));
  }
}
